// export { default } from './authentication';
import Authorization from "./authentication";

export default Authorization;
